import clsx from 'clsx';
import React from 'react';

import FlexLink from '@components/FlexLink';
import { useEventTracking } from '@hooks';
import { new_forum_post_path } from '@routes';
import { ClickTarget, click } from '@tracking';

import styles from './styles.module.scss';

export default function NewForumPostButton() {
  const { trackEvent } = useEventTracking();

  const handleWritePostClick = () => {
    trackEvent(click({ clickTarget: ClickTarget.WritePost }));
  };

  return (
    <div className={styles.writePostBtnWrapper}>
      <FlexLink
        href={new_forum_post_path()}
        className={clsx(styles.btn, styles.writePostBtn)}
        onClickCapture={handleWritePostClick}
      >
        Write a post
      </FlexLink>
    </div>
  );
}
